import type { GetInternalAuditReportObligationResultsByObligationIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportObligationAssessmentResultsByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportObligationAssessmentResultsByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetObligationInternalAuditResultsByObligationIdArgs = {
  obligationId: string;
};

export const useLazyGetObligationInternalAuditResultsByObligationId =
  createLazyQueryHook<
    UseLazyGetObligationInternalAuditResultsByObligationIdArgs,
    GetInternalAuditReportObligationResultsByObligationIdResponseRow[],
    GetInternalAuditReportObligationAssessmentResultsByObligationIdQuery
  >({
    trpcQuery: (client, { obligationId }) =>
      client.frontend.internalAuditResult.obligationInternalAuditResultsByObligationId.query(
        { obligationId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      obligation_internal_audit_result: data,
    }),
    graphqlDocument:
      GetInternalAuditReportObligationAssessmentResultsByObligationIdDocument,
    graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
  });
